var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('TextareaWithLabel',{attrs:{"label":_vm.showlabel == true ? _vm.Strings['Forms.Comments'] : '',"rows":"5"},model:{value:(_vm.comments),callback:function ($$v) {_vm.comments=$$v},expression:"comments"}})}
var staticRenderFns = []

export { render, staticRenderFns }